module.exports = __webpack_public_path__ + "img/navitas_logo_white.fa130695.png";